<div class="body-container">
  <div class="page-container">
    <div class="form-wrapper">
      <div class="form-content">
        <div class="form-section form-shipping-classes">
          <div class="form-section-side">
            <div class="form-section-container">
              <h1 class="label-title">Your API Keys</h1>
              <label class="label-subtitle">API keys provide full access to your Rebillia account, so keep them safe.</label>
            </div>
            <nav class="nav-links edit-link">
              <a [appRestriction]="'publicapi_account|limit|SCOPE_LIMIT'"  [routerLink]="['../create-api-credentials']" routerLinkActive="router-link-active" class="custom-mat-link link-option">Create New Keys</a>
            </nav>
          </div>
          <div class="form-section-container padding nopadding">
            <div class="form-section-inner">
              <div class="form-section-body">
                <div class="page-section">
                  <div class="page-section-body">
                    <section class="grid">
                      <div class="grid-content-wrapper">
                        <section [@onRowStatusChange]="statusForGridMessage" class="message message-grid">
                          <div class="message-wrapper">
                            <div class="message-inner">
                              <p class="message-description">No Store API Credentials found.</p>
                            </div>
                          </div>
                        </section>
                        <!-- Grid Content -->
                        <div *ngIf="isReadyApiKeys && statusForRestResponse == _visibleState.isVisible" class="grid-content">
                          <mat-list class="custom-mat-list list-grid-std list-api-keys">
                            <mat-list-item class="custom-mat-list-item grid-row grid-row-header">
                              <div class="cell-wrapper col-first">
                                <div class="cell col-date flex-order">
                                  <label class="label-header">Date Created</label>
                                </div>
                              </div>
                              <div class="cell-wrapper col-info">
                                <div class="cell col-user flex-order">
                                  <label class="label-header">Created By</label>
                                </div>
                                <div class="cell col-key flex-order">
                                  <label class="label-header">API key</label>
                                </div>
                                <div class="cell col-switch-status flex-order">
                                  <label class="label-header">Status</label>
                                </div>
                              </div>
                            </mat-list-item>
                            <mat-list-item *ngFor="let apiKeys of collectionOfApiKeys; let i = index;" class="custom-mat-list-item grid-row">
                              <!--Created At-->
                              <div class="cell-wrapper col-first">
                                <div class="cell col-date flex-order">
                                  <div class="cell-inner">
                                    <label matLine class="label-primary">{{apiKeys.apiTokenDate | dateTz:'fullDate'}}</label>
                                    <label matLine class="label-secondary">{{apiKeys.apiTokenDate | dateTz:'longTime'}}</label>
                                  </div>
                                </div>
                              </div>
                              <div class="cell-wrapper col-info">
                                <!-- User -->
                                <div class="cell col-user">
                                  <div class="cell-inner">
                                    <label class="label-primary">{{apiKeys.user.firstName}} {{apiKeys.user.lastName}}</label>
                                    <label class="label-secondary">{{apiKeys.user.username}}</label>
                                  </div>
                                </div>
                                <!-- API Key -->
                                <div class="cell col-key">
                                  <div class="cell-inner">
                                    <label matLine class="label-primary label-token">{{apiKeys.apiToken}}</label>
                                    <label class="label-secondary">Full Access</label>
                                  </div>
                                  <button mat-icon-button [cdkCopyToClipboard]="apiKey" class="custom-mat-icon-button">
                                    <mat-icon svgIcon="ico-copy" class="custom-mat-icon ico-size ico-xs"></mat-icon>
                                  </button>
                                </div>
                                <!-- Status -->
                                <div class="cell col-switch-status">
                                  <mat-slide-toggle [checked]="true" [disabled]="true" class="custom-mat-slide-toggle" color="primary"></mat-slide-toggle>
                                </div>
                              </div>
                            </mat-list-item>
                          </mat-list>
                        </div>
                        <!-- Grid Skeleton -->
                        <div *ngIf="!isReadyApiKeys" class="grid-content">
                          <mat-list class="custom-mat-list list-grid-std list-customer-invoices">
                            <!-- skeleton header -->
                            <mat-list-item class="custom-mat-list-item grid-row grid-row-header">
                              <div class="cell-wrapper col-first">
                                <div class="cell col-invoice flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                              </div>
                              <div class="cell-wrapper col-info">
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                              </div>
                            </mat-list-item>
                            <!-- skeleton body -->
                            <mat-list-item class="custom-mat-list-item grid-row">
                              <div class="cell-wrapper col-first">
                                <div class="cell col-invoice flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                              </div>
                              <div class="cell-wrapper col-info">
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                              </div>
                            </mat-list-item>
                          </mat-list>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-section form-shipping-classes">
          <div class="form-section-side">
            <div class="form-section-container">
              <h1 class="label-title">Webhooks</h1>
              <label class="label-subtitle">Webhooks enable you to send notifications to web applications in response to events in rebillia.</label>
            </div>
            <nav class="nav-links edit-link">
              <a  [routerLink]="['../new-webhook']" routerLinkActive="router-link-active" class="custom-mat-link link-option">Create Webhook</a>
            </nav>
          </div>
          <div class="form-section-container padding nopadding">
            <div class="form-section-inner">
              <div class="form-section-body">
                <div class="page-section">
                  <div class="page-section-body">
                    <section class="grid">
                      <div class="grid-content-wrapper">
                        <!-- <section [@onRowStatusChange]="statusForGridMessage" class="message message-grid">
                          <div class="message-wrapper">
                            <div class="message-inner">
                              <p class="message-description">No Store API Credentials found.</p>
                            </div>
                          </div>
                        </section> -->
                        <!-- Grid Content -->
                        <app-recent-events [config]="config" [dataSource]="dataSource" noResultsMessage="No webhooks found.">
                          <ng-template #cellTemplate let-element >
                            <ng-container *ngIf="element.col.cellTemplate === 'actiontemplate'">
                              <div class="cell-wrapper d-flex">
                              <button class="margin m__00160000"  mat-stroked-button
                              [matMenuTriggerFor]="menu" >  <mat-icon>double_arrow</mat-icon> Test</button>
                              <mat-menu #menu="matMenu">
                                  <button mat-menu-item *ngFor="let trigger of element.data.companyWebhookTriggers" (click)="testCompanyWebhookTriggers(element.data.id, trigger.id)">
                                      <mat-icon>double_arrow</mat-icon>
                                      <span>{{trigger.rblWebhookTrigger.name}}</span>
                                  </button>
                                </mat-menu>



                                <button mat-icon-button [matMenuTriggerFor]="actionmore" class="custom-mat-icon-button button-actions">
                                  <mat-icon svgIcon="ico-actions" class="custom-mat-icon ico-size ico-xs"></mat-icon>
                                </button>
                                <mat-menu #actionmore="matMenu" class="custom-mat-menu-panel">


                                  <a  mat-menu-item [routerLink]="'../edit-webhook/'+ element.data.id" class="custom-mat-menu-item">
                                    <mat-icon svgIcon="ico-edit" class="custom-mat-icon ico-size ico-1xs"></mat-icon>Edit
                                  </a>
                                  <a  mat-menu-item (click)="delete(element.data)" class="custom-mat-menu-item">
                                    <mat-icon svgIcon="ico-close-menu" class="custom-mat-icon ico-size ico-1xs"></mat-icon>Delete
                                  </a>
                                </mat-menu>
</div>
                              </ng-container>
                            <ng-container *ngIf="element.col.cellTemplate === 'triggerstemplate'">
                              <mat-chip-list>
                              <ng-container *ngFor="let trigger of element.data.companyWebhookTriggers">
                            <mat-chip>{{trigger.rblWebhookTrigger.name}}</mat-chip>
                            </ng-container></mat-chip-list>

                            </ng-container>
                          </ng-template>
                    </app-recent-events>

                        <ng-container *ngIf="false">
                        <div *ngIf="isReadyApiKeys && statusForRestResponse == _visibleState.isVisible" class="grid-content">
                          <mat-list class="custom-mat-list list-grid-std list-api-keys">
                            <mat-list-item class="custom-mat-list-item grid-row grid-row-header">
                              <div class="cell-wrapper col-first">
                                <div class="cell col-date flex-order">
                                  <label class="label-header">Date Created</label>
                                </div>
                              </div>
                              <div class="cell-wrapper col-info">
                                <div class="cell col-user flex-order">
                                  <label class="label-header">Created By</label>
                                </div>
                                <div class="cell col-key flex-order">
                                  <label class="label-header">API key</label>
                                </div>
                                <div class="cell col-switch-status flex-order">
                                  <label class="label-header">Status</label>
                                </div>
                              </div>
                            </mat-list-item>
                            <mat-list-item *ngFor="let apiKeys of collectionOfApiKeys; let i = index;" class="custom-mat-list-item grid-row">
                              <!--Created At-->
                              <div class="cell-wrapper col-first">
                                <div class="cell col-date flex-order">
                                  <div class="cell-inner">
                                    <label matLine class="label-primary">{{apiKeys.apiTokenDate | dateTz:'fullDate'}}</label>
                                    <label matLine class="label-secondary">{{apiKeys.apiTokenDate | dateTz:'longTime'}}</label>
                                  </div>
                                </div>
                              </div>
                              <div class="cell-wrapper col-info">
                                <!-- User -->
                                <div class="cell col-user">
                                  <div class="cell-inner">
                                    <label class="label-primary">{{apiKeys.user.firstName}} {{apiKeys.user.lastName}}</label>
                                    <label class="label-secondary">{{apiKeys.user.username}}</label>
                                  </div>
                                </div>
                                <!-- API Key -->
                                <div class="cell col-key">
                                  <div class="cell-inner">
                                    <label matLine class="label-primary label-token">{{apiKeys.apiToken}}</label>
                                    <label class="label-secondary">Full Access</label>
                                  </div>
                                  <button mat-icon-button [cdkCopyToClipboard]="apiKey" class="custom-mat-icon-button">
                                    <mat-icon svgIcon="ico-copy" class="custom-mat-icon ico-size ico-xs"></mat-icon>
                                  </button>
                                </div>
                                <!-- Status -->
                                <div class="cell col-switch-status">
                                  <mat-slide-toggle [checked]="true" [disabled]="true" class="custom-mat-slide-toggle" color="primary"></mat-slide-toggle>
                                </div>
                              </div>
                            </mat-list-item>
                          </mat-list>
                        </div>
                        <!-- Grid Skeleton -->
                        <div *ngIf="!isReadyApiKeys" class="grid-content">
                          <mat-list class="custom-mat-list list-grid-std list-customer-invoices">
                            <!-- skeleton header -->
                            <mat-list-item class="custom-mat-list-item grid-row grid-row-header">
                              <div class="cell-wrapper col-first">
                                <div class="cell col-invoice flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                              </div>
                              <div class="cell-wrapper col-info">
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                              </div>
                            </mat-list-item>
                            <!-- skeleton body -->
                            <mat-list-item class="custom-mat-list-item grid-row">
                              <div class="cell-wrapper col-first">
                                <div class="cell col-invoice flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                              </div>
                              <div class="cell-wrapper col-info">
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                                <div class="cell flex-order">
                                  <label matline>
                                    <skeleton-loader [theme]="{'width': '80px'}"></skeleton-loader>
                                  </label>
                                </div>
                              </div>
                            </mat-list-item>
                          </mat-list>
                        </div></ng-container>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
